import React from 'react'
import { useTranslation, TFunction } from 'react-i18next'
import IconDistributeData from '~/assets/images/distribute-data.svg'
import { StyledLonDashboard } from './styled'
import {
  DataItemProps,
  DistributeDataItem,
  LonDataNumberProps,
  OverviewDataItem,
} from './types'

const DataItem: React.FC<DataItemProps> = ({
  children,
  title,
  color,
  isPrimary,
}) => (
  <div className="data-item-wrapper">
    <div className="data-item-title-wrapper">
      {isPrimary && <div className="primary-circle" style={{ color }} />}
      <div className="data-item-title" style={{ color }}>
        {title}
      </div>
    </div>
    <div className="data-item-body">{children}</div>
  </div>
)

const LonDataNumber: React.FC<LonDataNumberProps> = ({ content, color }) => (
  <div className="lon-data-number" style={{ color }}>
    {parseInt(content, 10).toLocaleString()}
  </div>
)

const MAKE_OVERVIEW_DATA: (t: TFunction) => OverviewDataItem[] = (t) => [
  {
    title: t('lon_count'),
    titleColor: '#3253D7',
    body: <LonDataNumber color="#776CFE" content="200000000" key="lon_count" />,
  },
  {
    title: t('incentive_plan'),
    titleColor: '#F9C14D',
    body: (
      <LonDataNumber color="#F9C14D" content="130000000" key="incentive_plan" />
    ),
  },
  {
    title: t('buy_back'),
    titleColor: '#A9A1BF',
    body: (
      <div className="data-item-body-text">{t('buy_back_description')}</div>
    ),
  },
]

const MAKE_DISTRIBUTE_TOKEN_DATA: (t: TFunction) => DistributeDataItem[] = (
  t,
) => [
  {
    title: t('community_reward'),
    contentColor: '#433E72',
    content: '130000000',
  },
  {
    title: t('core_team'),
    contentColor: '#726CA7',
    content: '49680000',
  },
  {
    title: t('stakeholders'),
    contentColor: '#A7A3D4',
    content: '10320000',
  },
  {
    title: t('development_fund'),
    contentColor: '#D2D0E6',
    content: '10000000',
  },
]

export const LonDashboard: React.FC = () => {
  const { t } = useTranslation()
  const overviewDataItems = MAKE_OVERVIEW_DATA(t).map(
    ({ title, titleColor, body }, index) => (
      <DataItem
        color={titleColor}
        title={title}
        key={`${index}-${title}`}
        isPrimary
      >
        {body}
      </DataItem>
    ),
  )
  const distributeDataItems = MAKE_DISTRIBUTE_TOKEN_DATA(t).map(
    ({ title, content, contentColor }, index) => (
      <DataItem title={title} color="#6F6295" key={`${index}-${title}`}>
        <LonDataNumber color={contentColor} content={content} />
      </DataItem>
    ),
  )

  return (
    <StyledLonDashboard className="lon-dashboard-wrapper">
      <div className="lon-dashboard-inner">
        <div className="lon-dashboard-overview">{overviewDataItems}</div>
        <div className="division">{t('distribute_token')}</div>
        <div className="lon-dashboard-distribute-data-wrapper">
          <div className="lon-dashboard-distribute-data">
            {distributeDataItems}
          </div>
          <img
            className="distribute-data-img"
            src={IconDistributeData}
            alt=""
          />
        </div>
      </div>
    </StyledLonDashboard>
  )
}
